import getInstagram from '../module/libs/instagram';


const getInsta = new getInstagram();


export default class worksManager {
    constructor() {


    }
    init(){



    }
    render(mouse){


    }
    resize(){

    }
}